import React, { useContext, useState } from "react";
import { AppContext } from "../../App";
import { binData } from "../../rbac-consts";
import Can from "../can/Can";
import BinsContainer from "./admin/BinsContainer";

const BinsWrapper = () => {
  const { user } = useContext(AppContext);

  return (
    <Can
      role={user.roles}
      perform={binData.ADMIN}
      yes={() => (
        <BinsContainer />
      )}
    />
  );
}
export default BinsWrapper;